import { makeStyles } from 'tss-react/mui'
import { buyColor, sellColor } from '../../assets/colors'
import { alpha } from '@mui/material'
import { darkHoverBtnColor, lightHoverBtnColor } from '../../theme/theme'


export const useStyles = makeStyles()((theme) => {
    return {
        table: {
            border: 0
        },
        tableRow: {
            position: 'relative',
            background: alpha((theme.palette.mode === 'light') ? lightHoverBtnColor : darkHoverBtnColor, 0.3),
            '&:hover .square-off-button': {
                visibility: 'visible'
            }
        },
        tableCell: {
            padding: '5px',
            boxSizing: 'border-box',
        },
        closedPositionRow: {
            '& > td': {
                opacity: 0.5
            },
            '& > td .MuiBox-root[style*="position: absolute"]': {
                opacity: '1 !important'
            }
        },
        symbolCell: {
            width: '30%',
            textWrap: "nowrap",
            textOverflow: 'ellipsis',
            paddingLeft: theme.spacing(1)
        },
        qtyCell: {
            width: '10%',
            textAlign: "right"
        },
        oldQtyDisplay: {
            opacity: 0.4,
            marginRight: '5px'
        },
        averageCell: {
            width: '20%',
            textAlign: "right"
        },
        ltpCell: {
            width: '20%',
            textAlign: "right"
        },
        profitCell: {
            width: '15%',
            textAlign: "right"
        },
        buyQuantity: {
            color: buyColor
        },
        sellQuantity: {
            color: sellColor
        },
        squareOffCell: {
            width: 0,
            padding: 0,
            overflow: 'visible'
        },
        squareOffButton: {
            visibility: 'hidden',
            position: 'absolute',
            top: '0',
            right: '0',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            background: alpha(theme.palette.background.paper, 0.9),
            zIndex: 2,
            borderRadius: '4px'
        },
        profitColor: {
            color: 'var(--green-text-color)'
        },
        lossColor: {
            color: 'var(--red-text-color)'
        },

    }
})